export type AgGridFilters<T extends string> = Record<T, AgGridFiltersTypes>

export type AgGridFiltersTypes = TextFilter | DateFilter | SetFilter

type TextFilter = TextFilterSingle | TextFilterDouble

export enum AgGridFiltersOperators {
  AND = 'AND',
  OR = 'OR',
}

export enum AgGridFilterType {
  Text = 'text',
  Set = 'set',
  Date = 'date',
}

export enum AgGridFilterComparison {
  Contains = 'contains',
  Equals = 'equals',
  InRange = 'inRange',
}

interface TextFilterSingle {
  filter: string
  filterType: AgGridFilterType.Text
  type: AgGridFilterComparison.Contains
}

interface TextFilterDouble {
  filterType: string
  operator: AgGridFiltersOperators
  condition1: TextFilterSingle
  condition2: TextFilterSingle
}

export interface DateFilter {
  dateFrom: string
  dateTo?: string
  filterType: AgGridFilterType.Date
  type: AgGridFilterComparison.Equals | AgGridFilterComparison.InRange
}

interface SetFilter {
  value: Array<string>
  filterType: AgGridFilterType.Set
}

/**
 * This function verifies the type of the text filter.
 *
 * @return  {boolean}  is the text filter single?
 */

export function isTextFilterSingle(
  filter: TextFilter,
): filter is TextFilterSingle {
  return (filter as TextFilterSingle)?.filter !== undefined
}

export function isTextFilter(filter: AgGridFiltersTypes): filter is TextFilter {
  return filter?.filterType === AgGridFilterType.Text
}
